import { ajax } from '@/api/ajax'

//1、学生互评分页查询
export const reqMutualEvaluateList = (paramets) => ajax(`/jxclassroom/jxClassroomMutualEvaluation/list`, paramets)

//2、学生互评根据id获取学生
export const reqMutualEvaluateStuById = (paramets) => ajax(`/jxclassroom/jxClassroomMutualEvaluationStu/list`, paramets)

//3、学生互评获取学生得分详情
export const reqMutualEvaluateDetail = (paramets) => ajax(`/jxclassroom/jxClassroomActivityStu/getActStuDetails`, paramets)

//4、学生互评根据id删除
export const reqMutualEvaluateDelById = (paramets) => ajax(`/jxclassroom/jxClassroomMutualEvaluation/delete`, paramets, 'delete')

//5、过程性评价新增
export const reqStuRecordAdd = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/add`, paramets,"post")

//6、过程性评价新增
export const reqJxTypeById = (paramets) => ajax(`/jxclass/jxClass/queryListById`, paramets)

//7、学生过程性评价分页查询
export const reqScoreStuRecordList = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/getPageList`, paramets)

//8、学生过程性评价详情分页查询
export const reqShowStuOrGroupById = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/getPageDetailsList`, paramets)

//9、学生过程性评价学生/分组详情
export const reqShowStuOrGroupDetailsById = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/getPageDetails`, paramets)

//9、过程性评价删除
export const reqDelStuOrGroupByDate = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/deleteByDate`, paramets,"post")

//10、过程性评价详情删除
export const reqDelStuOrGroupById = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/delete`, paramets,"delete")

//11、过程性评价查询对于的分值
export const reqScore = (paramets) => ajax(`/jxclassroom/jxScoreStuRecord/getScore`, paramets)